import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { PageFinancialsProps } from 'client/bundles/types';

import './index.css';

import Doc from 'client/components/doc';
import FinancialsList from 'client/components/financials-list';
import { AutoscrollerStoragePrefix } from 'client/components/helpers/autoscroller';
import MenuYears from 'client/components/menu-years';
import TextNoData from 'client/components/text-no-data';

const b = cn('financials');
const bPageTitle = cn('page-title');

export default class Financials extends Component<PageFinancialsProps> {
    render() {
        const { title, yearReports, years, currentYear, messages, requestedArchive: isArchive, archiveData, tabArchive } = this.props;

        return (
            <div className={b()}>
                {
                    (yearReports || archiveData) ?
                        <>
                            <h1 className={bPageTitle()}>{title}</h1>

                            <div className={b('nav')}>
                                <div className={b('nav-years')}>
                                    {years && years.length > 0 &&
                                        <MenuYears
                                            currentYear={currentYear}
                                            years={years}
                                            storagePrefix={AutoscrollerStoragePrefix.Financials}
                                            isArchive={isArchive}
                                            />
                                    }
                                </div>

                                <div className={b('nav-archive')}>
                                    <a
                                        href="/financial-releases?archive"
                                        className={b('nav-link', { active: isArchive })}
                                        >
                                        {tabArchive}
                                    </a>
                                </div>
                            </div>

                            {
                                (isArchive && archiveData) ?
                                    <div className={b('archive')}>
                                        { Object.keys(archiveData)
                                            .reverse()
                                            .map(reportYear => {
                                                const reportYearDoc = archiveData.reports[reportYear];

                                                return Number(reportYear) ?
                                                    // @ts-ignore
                                                    <div className={b('year')} key={reportYearDoc.link}>
                                                        <h2 className={b('archive-year')}>{reportYear}</h2>

                                                        {
                                                            // @ts-ignore
                                                            reportYearDoc.link && reportYearDoc.title &&
                                                            <div className={b('year-report')}>
                                                                <Doc
                                                                    // @ts-ignore
                                                                    link={reportYearDoc.link}
                                                                    name={reportYearDoc.title}
                                                                    format="pdf"
                                                                    />
                                                            </div>
                                                        }

                                                        // @ts-ignore
                                                        <FinancialsList financials={archiveData[reportYear].reports} />
                                                    </div> : null;
                                            })}

                                        {
                                            archiveData && archiveData.text ?
                                                <div
                                                    className={b('text')}
                                                    // @ts-ignore
                                                    dangerouslySetInnerHTML={{ __html: archiveData.text }}
                                                    /> : null
                                        }
                                    </div> :
                                    // TODO: исправить
                                    // @ts-ignore
                                    <FinancialsList financials={yearReports} />
                            }
                        </> :
                        <TextNoData text={messages.notFound} />
                }
            </div>
        );
    }
}
